/*
*   File : breadcrumbs.js
*   Author : https://evoqins.com
*   Description : Breadcrumbs component
*   Integrations : NA
*   Version : 1.0.0
*/

import React from 'react';

//Custom component
import { Icon } from '../Icon';

const Breadcrumbs = (props) => {
    return (
        <div className={`${props.className} d-flex gap-1  gap-sm-2 align-items-center flex-wrap`}>
            {
                props.data.map((data, key) => (
                    <div key={key} className='d-flex gap-1 gap-sm-2 align-items-center'>
                        {data.id !== 1 &&
                            <Icon icon="arrow-right"
                                color={key !== props.data.length - 1 ? "#64748B" : "#141514"}
                                className="d-flex"
                                size="10px" />
                        }
                        <span className={`${key !== props.data.length - 1 ? 'e-text-slate-gray cursor-pointer' : 'e-text-chinese-black pe-none'} e-font-12-res e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px`}
                            onClick={() => props.handleNavigate(data)}>
                            {data.label}
                        </span>
                    </div>
                ))
            }
        </div>
    )
}

export default Breadcrumbs;

Breadcrumbs.defaultProps = {
    handleNavigate: () => { }
};
